import { useEffect, useState } from 'react'

import {
  getConceptsWithAmount,
  getConceptsWithItemAmount,
  getConceptsWithToggledConcept,
  getSumOfSelectedConcepts,
  hasAmountErrors,
} from '@/returns/helpers/helpers'
import useRefundMethodExtra from '@/returns/hooks/useRefundMethodExtra/useRefundMethodExtra'

const useEditTransactionAmount = ({ concepts, refundMethod, returnId, show }) => {
  const [note, setNote] = useState('')
  const [transactionConcepts, setTransactionConcepts] = useState([])
  const [refundMethodSelected, setRefundMethodSelected] = useState(null)

  const getSelectedConcepts = () => transactionConcepts?.filter(concept => concept?.selected)

  const conceptsAmount = getSumOfSelectedConcepts(getSelectedConcepts())
  const hasConceptAmountErrors = hasAmountErrors(transactionConcepts)

  const { amount: refundMethodExtraAmount } = useRefundMethodExtra({
    returnId: returnId,
    amount: conceptsAmount,
    refundMethod: refundMethodSelected,
    skip: hasConceptAmountErrors,
  })

  useEffect(() => {
    if (show) {
      setNote('')
      setTransactionConcepts(concepts)
      setRefundMethodSelected(refundMethod)
    }
  }, [concepts, refundMethod, show])

  const onSelectConcept = concept => {
    setTransactionConcepts(prevConcepts => getConceptsWithToggledConcept(prevConcepts, concept.id))
  }

  const onChangeConceptAmount = (conceptId, amount) => {
    setTransactionConcepts(prevConcepts => getConceptsWithAmount(prevConcepts, conceptId, amount))
  }

  const onChangeItemAmount = (conceptId, itemId, amount) => {
    setTransactionConcepts(prevConcepts => getConceptsWithItemAmount(prevConcepts, conceptId, itemId, amount))
  }

  const isFormValid = () => {
    if (hasConceptAmountErrors) return false

    if (conceptsAmount > 0) {
      return note?.length > 0 && refundMethodSelected !== null
    } else {
      return note?.length > 0
    }
  }

  return {
    note,
    setNote,
    transactionConcepts,
    refundMethodSelected,
    setRefundMethodSelected,
    getSelectedConcepts,
    onSelectConcept,
    onChangeConceptAmount,
    onChangeItemAmount,
    refundMethodExtraAmount,
    hasConceptAmountErrors,
    isFormValid,
  }
}

export default useEditTransactionAmount
